/* global google  */
/**
 * Exports a factory function that returns a google.maps.LatLngBounds
 * instance surrounding Enschede.
 *
 * The coordinates for this bounding box are extracted from a
 * Google Maps geocoding lookup.
 */

/*
// To update the bounding box data copy the `getBounds`
// function into the Chrome console and then call it.
//
// The new bounding box data will be logged in the console.

const getBounds = () =>
  fetch('https://maps.googleapis.com/maps/api/geocode/json?address=Enschede')
    .then(response =>
      response.json()
        .then(data =>
          console.log(JSON.stringify(
            [
              data.results[0].geometry.bounds.southwest,
              data.results[0].geometry.bounds.northeast
            ]))))
*/

export default () => {
  /**
   * Returns a bounding box that contains all the regions.
   */
  return new google.maps.LatLngBounds(
    // South/West
    { lat: 52.1610969, lng: 6.7559429 },
    // North/East
    { lat: 52.2854608, lng: 6.9811527 },
  )
}
